import { useMemo, useState } from 'react';
import { CopyButton, Field, useToast } from '../components/ui';
import { api } from '../lib/api';
import { errText } from './components';
import { ChannelAccount } from './model';
import { encodeQr, qrSvgPath } from './qr';
import { currentLocale, t } from '../lib/i18n';

export function Qr({ text }: { text: string }) {
  const q = useMemo(() => {
    try {
      return qrSvgPath(encodeQr(text));
    } catch {
      return null;
    }
  }, [text]);
  if (!q) return null;
  return (
    <svg className="qr" viewBox={`0 0 ${q.view} ${q.view}`} role="img" aria-label={t('QR-код ссылки привязки')} shapeRendering="crispEdges">
      <rect width={q.view} height={q.view} fill="#fff" />
      <path d={q.d} fill="#04182f" />
    </svg>
  );
}

/** A one-time link for a contact (also on the contact card): copy or show as QR. */
export function TelegramLinkMaker({ contactId: fixed, bots }: { contactId?: string; bots: ChannelAccount[] }) {
  const toast = useToast();
  const [contact, setContact] = useState(fixed ?? '');
  const [bot, setBot] = useState(bots[0]?.id ?? '');
  const [marketing, setMarketing] = useState(false);
  const [link, setLink] = useState<{ url: string; expires_at: string } | null>(null);
  async function make() {
    try {
      setLink(await api.post<{ url: string; expires_at: string }>(`/contacts/${contact.trim()}/telegram-link`, { ...(bot ? { account: bot } : {}), marketing }));
    } catch (err) {
      toast(errText(err), 'bad');
    }
  }
  if (!bots.length) return <div className="small muted">{t('Подключите бота, чтобы создавать ссылки.')}</div>;
  return (
    <div className="stack" style={{ gap: 8 }}>
      {!fixed && <Field label={t('Контакт')}><input className="input input-mono" placeholder="con_…" value={contact} onChange={(e) => setContact(e.target.value)} /></Field>}
      {bots.length > 1 && (
        <Field label={t('Бот')}>
          <select className="select input" value={bot} onChange={(e) => setBot(e.target.value)}>
            {bots.map((b) => <option key={b.id} value={b.id}>{typeof b.config.bot_username === 'string' ? `@${b.config.bot_username}` : b.name}</option>)}
          </select>
        </Field>
      )}
      <label className="row small" style={{ cursor: 'pointer' }}><input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} /> {t('Человек также соглашается на маркетинговые сообщения')}</label>
      <button className="btn btn-sm" style={{ alignSelf: 'flex-start' }} disabled={!contact.trim().startsWith('con_')} onClick={make}>{t('Создать ссылку')}</button>
      {link && (
        <div className="row wrap" style={{ gap: 12, alignItems: 'flex-start' }}>
          <Qr text={link.url} />
          <div className="stack" style={{ gap: 6, minWidth: 0, flex: 1 }}>
            <code className="cell-wrap">{link.url}</code>
            <CopyButton small value={link.url} />
            <span className="small muted">{t('Одноразовая, действует до {time}. Человек нажимает «Start» — чат привязывается к контакту.', { time: new Date(link.expires_at).toLocaleTimeString(currentLocale(), { hour: '2-digit', minute: '2-digit' }) })}</span>
          </div>
        </div>
      )}
    </div>
  );
}

